// eslint-disable-next-line import/prefer-default-export
export const isFormValid = (fields) => Object.values(fields).every((val) => val === true);
